import { render, staticRenderFns } from "./DepositBanner.vue?vue&type=template&id=f53643ce"
import script from "./DepositBanner.vue?vue&type=script&lang=js"
export * from "./DepositBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
